import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.appPage.DOC}
  query AppPages($zoneId: ID!, $tenantId: ID!, $appId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          pages {
            ...FragmentAppPage
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AppPagesQuery,
    ents.core.admin.App.Page[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'pages',
          graphql.transformers.OUT.list(fragments.appPage.TRANSFORMER, {
            onNullish: 'remove',
          }),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.AppPagesQuery,
  ents.core.admin.App.Page[],
  graphql.schema.AppPagesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
